<template lang="html">
  <block-render :blocks="content" v-if="content"></block-render>    
  <div class="" v-else="" style="height: 1000px;"></div>
</template>

<script>
import sanityQuery from '@/sanityQuery'

export default {
  data () {
    return {
      content: null
    }
  },
  created () {
    const query = `*[_id == "3cce2543-6b7d-47b6-a277-f5d6448e3e0c" && !(_id in path "drafts.**")]
    {
      "blocks": blocks {
        "content": content[] {
          ...,
          "frontPageIssues": frontPageIssues[] {
            lead,
            "issue": frontPageIssue-> {
              title,
              slug,
              "image": image {
                ...,
                "asset": asset->{url, metadata}
              }
            }
          },
          "image": image{"asset": asset->{url, metadata}},
          "members": members[] {
            role,
            "person": person->{
              ...,
              "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}
            }
          }
        }
      }
    }`

    sanityQuery(query)
      .then((result) => {
        this.content = result[0].blocks.content
      })
  },
  metaInfo () {
    return {
      title: 'Rød Ungdom \u2014 Organisasjonen', // set a title
      htmlAttrs: {
        lang: 'no',
        amp: undefined // "amp" has no value
      },
      meta: [
        {name: 'title', content: 'Rød Ungdom \u2014 Organisasjonen'},
        {name: 'description', content: 'Her kan du lese mer om vår organisasjon, og bli medlem.'},
        {name: 'twitter:title', content: 'Rød Ungdom'},
        {name: 'twitter:description', content: 'Her kan du lese mer om vår organisasjon, og bli medlem.'},
        {name: 'twitter:image', content: 'https://xn--rdt-0na.no/images/standard_delebilde_fb.png'},
        {property: 'og:title', content: 'Rød Ungdom \u2014 Organisasjonen'},
        {property: 'og:description', content: 'Her kan du lese mer om vår organisasjon, og bli medlem.'},
        {property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'},
        {property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path}
      ]
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Partiet.vue